export default __webpack_public_path__ + "static/article-credit-card-fraud-busters-fa687d3d9317275c0d5ff87d8998de27.jpg";